import React from 'react';
import { FileTextIcon, ZapIcon, CalendarDaysIcon, DumbbellIcon, SaladIcon } from 'lucide-react';
import { gluteDeliverables } from '../../data/gluteCopy';
const icons = [FileTextIcon, ZapIcon, CalendarDaysIcon, DumbbellIcon, SaladIcon];
export function GluteIncludes() {
  return <section aria-labelledby="glute-incluye" className="w-full bg-coal" data-id="element-68" data-mp="1ftso7eqyvakm">
      <div className="mx-auto w-full max-w-5xl px-5 py-16 sm:px-8 sm:py-24 lg:py-32" data-id="element-69" data-mp="1fwonp7igq7b6">
        <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-70" data-mp="s6ub8r222krg">
          Lo que recibes
        </p>
        <h2 id="glute-incluye" className="mt-5 max-w-2xl text-[1.75rem] font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl" data-id="element-71" data-mp="1156blksq4wx3">
          Todo el sistema, disponible al instante
        </h2>

        <ul className="mt-10 divide-y divide-coal-line border-y border-coal-line sm:mt-14" data-id="element-72" data-mp="2cj0a4nvhzlp2">
          {gluteDeliverables.map((item, index) => {
          const Icon = icons[index] ?? FileTextIcon;
          return <li key={item.title} className="flex gap-4 py-5 sm:gap-6 sm:py-7" data-id="element-73" data-mp="3kjo8f6q5l8me" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-coal-card sm:h-12 sm:w-12" aria-hidden="true" data-id="element-74" data-mp="3ohm1ikn1oev2">
                  <Icon className="h-5 w-5 text-ember" data-id="element-75" data-mp="2b79511oftpm" />
                </span>
                <div data-id="element-76" data-mp="30uxczg3j5o5h">
                  <h3 className="text-[1.02rem] font-semibold leading-snug text-white sm:text-lg" data-id="element-77" data-mp="30vfgmxsiv4nf">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 max-w-2xl text-[0.92rem] leading-relaxed text-white/50 sm:text-base" data-id="element-78" data-mp="3ariis3ndj3ad">
                    {item.text}
                  </p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}